module.exports = __webpack_public_path__ + "static/22_tat10-b25de904dd2278ee1ba994075350020e.jpg";